import SettingsModule, {SettingsMenuTopCategory} from "../../../../core/modules/settings-module";
import {SettingsParentSection} from "../../../settings/const";

export default class ZapierSettingsModule extends SettingsModule {

    constructor() {
        super({
            name                     : "Zapier",
            description              : "The Zapier Integration module allows you to connect your workspace with thousands of other services, enabling you to automate workflows, sync data, and trigger actions across a wide range of applications, enriching your productivity and extending the functionality of your workspace without the need for in-depth coding.",
            svgIcon                  : "isvg-zapier-integration",
            settingsUrl              : "settings/integrations/zapier",
            settingsMenuTopCategory  : SettingsMenuTopCategory.INTEGRATIONS,
            typeLabel                : "Integrations"

        });

        this.parentSection          = SettingsParentSection.INTEGRATIONS
    }

}
